export default __webpack_public_path__ + "static/media/biote_lapis1.596681b6.png";